import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import docusignService from "../../services/docusign.service";

// #65 - one optional release-letter signing for the whole request. A single
// DocuSign envelope (Add Carrier Release template) covers every transferring
// carrier the agent marked as having a release, listed below. Signing is a
// full-page redirect (like the payment DocuSign) and returns to
// /contract/release-signing-return/:id, which rehydrates the wizard here with the
// release marked Signed (via data.releaseSigned). Signing is optional: Submit to
// sign, or skip and continue.
const CarrierRelease = ({ data, completeStep }) => {
  const releaseCarriers = (data?.contracts || []).filter(
    (c) => c.policyCreation === "transfer" && c.withRelease === true
  );

  const signed = !!data?.releaseSigned;
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submitRelease = () => {
    setBusy(true);
    setError(null);
    docusignService
      .startReleaseSigning({ ...data, unsignedId: data.unsignedId })
      .then(({ signingUrl }) => {
        // Full-page navigation, exactly like the payment DocuSign step.
        window.location.href = signingUrl;
      })
      .catch((err) => {
        setError(
          `There was a problem starting the release signing: ${
            err?.response?.data?.message || err.message
          }`
        );
        setBusy(false);
      });
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Paper sx={{ p: 4, maxWidth: 640, width: "100%" }} elevation={2}>
        <Typography variant="h6" align="center">
          Sign your carrier release letter
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mb: 3 }}
        >
          You marked a release letter for the carriers below. One release covers all
          of them. Signing is optional: submit it now, or skip and continue.
        </Typography>

        <TableContainer sx={{ mb: 3 }}>
          <Table aria-label="Carrier releases">
            <TableHead>
              <TableRow>
                <TableCell>Carrier</TableCell>
                <TableCell align="right">Release letter</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {releaseCarriers.map((c) => (
                <TableRow key={c.value}>
                  <TableCell>{c.label}</TableCell>
                  <TableCell align="right">Included</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {signed ? (
          <>
            <Button
              fullWidth
              variant="outlined"
              color="success"
              disabled
              startIcon={<CheckCircleIcon />}
              sx={{ mb: 2 }}
            >
              Release signed
            </Button>
            <Button fullWidth variant="contained" onClick={() => completeStep({})}>
              Next
            </Button>
          </>
        ) : (
          <>
            <Button
              fullWidth
              variant="contained"
              disabled={busy}
              onClick={submitRelease}
              startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null}
              sx={{ mb: 2 }}
            >
              {busy ? "Taking you to DocuSign..." : "Submit"}
            </Button>
            <Button fullWidth variant="text" onClick={() => completeStep({})}>
              Skip and continue
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default CarrierRelease;
